import { render, staticRenderFns } from "./VendorOverride.vue?vue&type=template&id=555babd4&scoped=true&"
import script from "./VendorOverride.vue?vue&type=script&lang=ts&"
export * from "./VendorOverride.vue?vue&type=script&lang=ts&"
import style0 from "./VendorOverride.vue?vue&type=style&index=0&id=555babd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555babd4",
  null
  
)

export default component.exports